// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billboard-search {
  display: flex;
  justify-content: end;
}

.arrow-align {
  cursor: pointer;
  width: 1.5rem !important;
  height: 1.5rem !important;
}

.my-billboard-container {
  margin: 0rem 4rem 0rem 4rem;
}
.billboard-search-btn {
  margin-left: 15.5px;
  color: #fff !important;
  display: inline-flex;
  height: 50px;
  padding: 8px 60px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #d2042d !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border: none;
}
.more-slots-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 6px !important;
}
.more-slots-dates-text {
  font-family: Roboto;
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
.billBoard-actions {
  width: 100%;
  justify-content: end;
  align-items: center;
}
.billboard-divider {
  margin: 0;
}

.billboard-selected-segment {
  display: flex;
  align-items: center;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 0.4rem 1.25rem;
  cursor: pointer;
}

.billboard-non-selected-segment {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.billboard-segments {
  font-family: Roboto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  margin: 1rem 0 1rem 0rem;
  font-family: "Roboto";
  font-weight: 600;

  .ant-segmented-item {
    border-radius: 10px;
  }
  .ant-segmented-item {
    width: 33.33%;
    color: #000;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .ant-segmented-item-selected {
    font-weight: 600;
  }
}
.billboards-count {
  background: #f5f5f5;
  padding: 8px;
  margin-left: 8px;
}
.filter-billBoards {
  width: 100%;
  margin-top: 1.5rem;
  align-items: center;
  gap: 0.5rem;
}
.billboard-filter {
  height: 40px;
  gap: 0.5rem;
  display: flex;
  align-items: center;
  color: var(--Colors-Text-500, #0a0f0d);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  .filter-text {
    font-family: Roboto;
    color: var(--Colors-Text-300, #5b5e5d);
  }
}
.endDatePicker {
  margin-left: 0.5rem;
}
.billboard-container {
  margin-top: 2rem;
  width: 100%;
  .ant-ribbon.ant-ribbon-placement-end {
    font-family: Roboto;
    padding: 0.5rem 1rem;
    top: -2.25rem;
    border-radius: 10px 10px 0 0;
  }
}
.my-billboard-card {
  width: 100%;
  .product-align {
    margin-right: 25px;
  }
  .product-img {
    height: 132px;
    margin-right: 39px;
    border-radius: 5px;
  }
}
.button-group {
  display: flex;
  justify-content: end;
  margin-right: 0.5rem !important;
}
.product-actions {
  height: 35px;
  padding: 8px 26px;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  gap: 8px;
  flex-shrink: 0;
  background: #f5f5f5;
  border-radius: 5px;
  font-weight: 500;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
}
.transfer-btn {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d) !important;
  margin-left: 1rem;
  border: 1px solid #000 !important;
}
.bulk-upload-btn {
  font-family: Roboto;
  background: #f5f5f5;
  max-width: fit-content;
  border: 1px solid #000 !important;
  color: var(--Colors-Text-500, #0a0f0d) !important;
}
.add-new-btn {
  font-family: Roboto;
  background: #d2042d !important;
  color: #fff !important;
  border: none;
}
.billboard-details {
  font-family: Roboto;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #5b5e5d;
  font-size: 14px;
}
.feature-actions {
  display: flex;
  align-items: center;
  justify-content: end;
}
.featured-section {
  font-family: Roboto;
  border-radius: 5px;
  color: #d2042d;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-weight: 400;
  font-size: 1rem;
  flex-shrink: 0;
  cursor: pointer;
}
.map-label {
  font-family: Roboto;
  margin-right: 8px;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: inline-block;
  padding-top: 0.4rem;
}
.switch-map {
  width: 53px;
  height: 26px;
}
.product-price {
  color: #000;
  font-size: var(--Font-Font-Size-h4, 20px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 21px;
  justify-content: end;
  align-self: center;
}
.price-details {
  font-family: Roboto;
  display: inline-flex;
}
.action-buttons {
  margin-top: 32px;
  justify-content: end;
}
.delete-button {
  padding: 0;
}
.negotiable-text {
  font-family: Roboto;
  color: var(--Colors-Text-300, #5b5e5d);
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 4px;
  margin-top: 10px;
}

.transfer-product-header {
  font-family: Montserrat;
  color: #000;
  font-size: var(--Font-Font-Size-h5, 1.4375rem);
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
}

.transfer-product-seller {
  margin-top: 2rem;
  margin-bottom: 2.5rem;
}

.transfer-product-radio .ant-radio-wrapper > span {
  color: #000;
  font-size: 1rem !important;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
}

.transfer-product-radio .ant-radio-inner {
  width: 20px;
  height: 20px;
}

.transfer-product .ant-select-item-option-state {
  display: none !important;
}

.transfer-product-chip {
  text-align: center;
  padding: 0.5rem 0.625rem;
  border-radius: 0.1875rem;
  background: #ffd6de;
  gap: 0.5rem;
  display: flex;
}

.transfer-product-chip .ant-tag-close-icon {
  color: #000;
}
.pagination {
  display: flex;
  padding: 1rem;
  justify-content: end;
}

.product-labels {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.available-check {
  .ant-checkbox-inner {
    height: 1.5rem;
    width: 1.5rem;
  }
}
.filter-billBoards .vertical-divider {
  stroke-width: 1px;
  background-color: #000;
  height: 1.6875rem;
  margin: 0 1rem;
}
.datepickers {
  position: relative;
}
.datepickers .ant-picker-panel-container {
  width: 100% !important;
}

.select-type-drop-down {
  width: auto !important;
}

.my-billboard-datepicker {
  height: 2.375rem;
  display: flex;
  font: 0.8125rem;
  padding: 0px 14px;
  align-items: center;
  gap: 12px;
  border-radius: 5px;
  width: 10.5rem;
  border: 1px solid #e6e6e6;
  border-bottom: none;
  background: #fff;
  .ant-picker-input > input::placeholder {
    font-family: Roboto;
    color: #0a0f0d;
  }
}

.personal-details-datepicker {
  border-color: #e6e6e6 !important;
  border-bottom: 1px solid #e6e6e6 !important;
  box-shadow: none !important;
}

.isAvailable {
  font-family: Roboto;
  width: max-content;
}
.my-billboard-datepicker-dropdown .ant-picker-date-panel {
  width: 100% !important;
}

.filter-billBoards .ant-picker-panel-container.ant-picker-date-panel-container {
  width: 15rem !important;
}
.ribbon-margin {
  margin-top: 3.25rem;
}
.my-billboard-card .siteNumber {
  color: var(--Colors-Primary-500, #8e9190);
}
.billboard-container .product-title {
  font-family: Roboto;
  word-wrap: break-word !important;
  max-width: 80% !important;
}

.my-billboard-campaign-div {
  gap: 0.5rem;
  display: flex;
}

.my-billboard-campaign-col {
  display: flex;
  gap: 0.5rem;
}

.siteName-image {
  width: 22px !important;
  margin: 12px;
}

.my-billboard-actions-div {
  justify-content: flex-end;
  display: flex;
}
.my-products-header {
  margin-top: 10px;
  height: 90px;
  align-items: center;
}
.my-billboard-divider {
  height: 23px;
  border-inline-start: 1px solid rgb(5 5 5 / 48%);
  margin: 1.125rem;
}

.my-billboard-back-arrow {
  padding-left: 1rem;
  padding-top: 1rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.my-billboard-tag-css {
  margin-top: 1rem;
  display: flex;
  gap: 0.2rem;
  max-height: 4rem;
  overflow-x: scroll;
  flex-wrap: wrap;
}

.billboard-clear-all {
  font-family: Roboto;
  margin-left: 1rem;
  cursor: pointer;
  color: #d2042d;
}
.mobile-products-row {
  overflow-y: scroll;
  max-height: 65vh;
  /* padding-right: 1rem; */
}
.slots-popover {
  max-height: 25vh !important;
  overflow-y: auto;
}
@media (min-width: 481px) and (max-width: 1025px) {
  .my-billboard-card .product-labels {
    font-size: 0.9rem;
  }
  .my-billboard-card .siteName {
    font-size: 15px;
  }
  .available-check {
    padding: 4px 10px 4px 0px;
  }
  .button-group {
    justify-content: flex-start !important;
    margin-top: 1rem;
  }
  .map-section {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }
  .map-section .map-label {
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 768px) {
  .campaign,
  .my-product {
    min-width: 100vw I !important;
  }
  .my-billboard-container {
    margin: 0rem 1.5rem;
  }

  .impressions-row {
    border-radius: 10px;
    background: var(--Colors-Background-300, #f8f8f8);
    width: 100%;
    max-width: 85vw;
    height: auto;
    padding: 10px 0;
    flex-shrink: 0;
    margin-top: 1.3125rem;
    justify-content: center;
    align-items: center;
  }
  .mobile-products-row .product-title {
    font-size: 13px;
  }
  .price-actions {
    justify-content: space-between;
    margin-top: 1.1875rem;
  }
  .billboard-filter {
    padding: 10px;
    width: max-content;
    background: #fff;
    border-radius: 10px;
  }
  .map-label {
    font-size: 13px;
    margin-right: 0;
    padding-top: 0.2rem;
  }
  .my-billboard-card .ant-card-body {
    padding: 14px;
  }
  .my-billboard-card .product-title {
    font-weight: 400;
  }
}

@media (min-width: 0px) and (max-width: 769px) {
  .custom-button {
    background-color: #d2042d !important;
    color: #fff !important;
    height: 3rem !important;
    width: 3rem !important;
    font-size: 24px;
  }
  .my-billboard-campaign-div {
    font-size: 1.4rem;
  }
  .my-products-header {
    margin-top: 10px;
    height: auto;
    align-items: center;
  }
  .seller-multi-slot-arrow {
    margin: 6px !important;
  }
  .floating-icon {
    position: fixed;
    bottom: 24px;
    right: 13px;
    z-index: 99;
  }
  .address-section {
    margin-top: 15px !important;
  }
  .more-slots-dates-text {
    font-size: 14px !important;
  }
}

@media (min-width: 0px) and (max-width: 480px) {
  .view-campaigns-header {
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h6, 1.1875rem);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    height: max-content;
  }
  .billboard-search {
    margin-left: 0rem;
    width: 100%;
  }
  .billboard-container {
    display: inline-block;
    margin-top: 2rem;
    .ant-ribbon.ant-ribbon-placement-end {
      right: 0.1%;
    }
    .ant-ribbon-wrapper {
      margin-top: 1.5rem;
    }
  }
  .product-card .ant-row {
    padding: 0;
  }
  .billboard-segments {
    width: 100%;
    overflow-x: scroll;
  }
  .button-group {
    justify-content: flex-start;
    flex-wrap: nowrap;
    margin-top: 0.5rem;
    width: 365px;
    overflow-x: scroll;
  }
  .featured {
    color: var(--Colors-Primary-500, #d2042d);
    font-size: var(--Font-Font-Size-small, 13px);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .folder-icon {
    padding-right: 10px;
  }
  .switch-map {
    width: 33px;
    height: 26px;
    margin-left: 0.5rem;
  }
  .my-billboard-card .siteNumber {
    color: var(--Colors-Primary-500, #d2042d);
  }
  .product-details-value {
    color: #000;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .my-billboard-card .dates {
    margin-top: 1rem;
  }
  .product-labels {
    font-size: 13px;
  }
  .product-img-section {
    margin-top: 2rem;
  }
  .address-section {
    margin-top: 3px;
  }
  .product-img {
    width: 120px;
    height: 104px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 0.5px solid grey;
  }
  .product-price {
    justify-content: flex-start;
    flex-direction: column;
  }
  .negotiable-text {
    margin-top: 0;
  }
  .dates-arrow {
    padding: 0 0.5rem;
  }

  .custom-button {
    background-color: #d2042d !important;
    color: #fff !important;
    height: 3rem !important;
    width: 3rem !important;
    font-size: 24px;
  }
  .align-flex {
    display: flex;
    flex-direction: column;
  }
  .action-btns {
    font-family: Roboto;
    align-self: flex-start;
  }

  .price-details {
    overflow: hidden;
    color: #000;
    text-overflow: ellipsis;
    font-size: var(--Font-Font-Size-h5, 23px);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .billboard-action-button {
    border: none;
    border-radius: 5px;
    background: #f5f5f5;
    display: flex;
    width: 51px;
    height: 50px;
    padding: 3px 7px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
  .floating-icon {
    position: fixed;
    bottom: 24px;
    right: 13px;
    z-index: 99;
  }

  .align-flex {
    display: flex;
    flex-direction: column;
  }
  .action-btns {
    align-self: flex-start;
  }
  .price-actions {
    justify-content: space-between;
    margin-top: 1.1875rem;
  }
  .price-details {
    overflow: hidden;
    color: #000;
    text-overflow: ellipsis;
    font-size: var(--Font-Font-Size-h5, 23px);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .billboard-action-button {
    border: none;
    border-radius: 5px;
    background: #f5f5f5;
    display: flex;
    width: 51px;
    height: 40px;
    padding: 3px 7px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
}

.myBillboard-icons {
  width: 1rem;
  height: 1rem;
}
@media (max-width: 768px) {
  .product-labels {
    font-size: 14px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/SellerFlow/dashboard/billboards/MyBillboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gDAAgD;EAChD,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;;EAEhB;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB;IACE,mBAAmB;IACnB,sCAAsC;EACxC;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX;IACE,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,4BAA4B;EAC9B;AACF;AACA;EACE,WAAW;EACX;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,iCAAiC;EACjC,iDAAiD;AACnD;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB;IACE,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sCAAsC;IACtC,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,6BAA6B;EAC/B;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iDAAiD;IACjD,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB;MACE,WAAW;IACb;IACA;MACE,kBAAkB;IACpB;EACF;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,yCAAyC;IACzC,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;EACA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".billboard-search {\n  display: flex;\n  justify-content: end;\n}\n\n.arrow-align {\n  cursor: pointer;\n  width: 1.5rem !important;\n  height: 1.5rem !important;\n}\n\n.my-billboard-container {\n  margin: 0rem 4rem 0rem 4rem;\n}\n.billboard-search-btn {\n  margin-left: 15.5px;\n  color: #fff !important;\n  display: inline-flex;\n  height: 50px;\n  padding: 8px 60px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #d2042d !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  border: none;\n}\n.more-slots-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 6px !important;\n}\n.more-slots-dates-text {\n  font-family: Roboto;\n  color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n}\n.billBoard-actions {\n  width: 100%;\n  justify-content: end;\n  align-items: center;\n}\n.billboard-divider {\n  margin: 0;\n}\n\n.billboard-selected-segment {\n  display: flex;\n  align-items: center;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.05);\n  padding: 0.4rem 1.25rem;\n  cursor: pointer;\n}\n\n.billboard-non-selected-segment {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.billboard-segments {\n  font-family: Roboto;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  margin: 1rem 0 1rem 0rem;\n  font-family: \"Roboto\";\n  font-weight: 600;\n\n  .ant-segmented-item {\n    border-radius: 10px;\n  }\n  .ant-segmented-item {\n    width: 33.33%;\n    color: #000;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .ant-segmented-item-selected {\n    font-weight: 600;\n  }\n}\n.billboards-count {\n  background: #f5f5f5;\n  padding: 8px;\n  margin-left: 8px;\n}\n.filter-billBoards {\n  width: 100%;\n  margin-top: 1.5rem;\n  align-items: center;\n  gap: 0.5rem;\n}\n.billboard-filter {\n  height: 40px;\n  gap: 0.5rem;\n  display: flex;\n  align-items: center;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  .filter-text {\n    font-family: Roboto;\n    color: var(--Colors-Text-300, #5b5e5d);\n  }\n}\n.endDatePicker {\n  margin-left: 0.5rem;\n}\n.billboard-container {\n  margin-top: 2rem;\n  width: 100%;\n  .ant-ribbon.ant-ribbon-placement-end {\n    font-family: Roboto;\n    padding: 0.5rem 1rem;\n    top: -2.25rem;\n    border-radius: 10px 10px 0 0;\n  }\n}\n.my-billboard-card {\n  width: 100%;\n  .product-align {\n    margin-right: 25px;\n  }\n  .product-img {\n    height: 132px;\n    margin-right: 39px;\n    border-radius: 5px;\n  }\n}\n.button-group {\n  display: flex;\n  justify-content: end;\n  margin-right: 0.5rem !important;\n}\n.product-actions {\n  height: 35px;\n  padding: 8px 26px;\n  justify-content: center;\n  align-items: center;\n  display: inline-flex;\n  gap: 8px;\n  flex-shrink: 0;\n  background: #f5f5f5;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: 14px;\n  font-style: normal;\n  line-height: normal;\n}\n.transfer-btn {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d) !important;\n  margin-left: 1rem;\n  border: 1px solid #000 !important;\n}\n.bulk-upload-btn {\n  font-family: Roboto;\n  background: #f5f5f5;\n  max-width: fit-content;\n  border: 1px solid #000 !important;\n  color: var(--Colors-Text-500, #0a0f0d) !important;\n}\n.add-new-btn {\n  font-family: Roboto;\n  background: #d2042d !important;\n  color: #fff !important;\n  border: none;\n}\n.billboard-details {\n  font-family: Roboto;\n  margin-top: 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #5b5e5d;\n  font-size: 14px;\n}\n.feature-actions {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n.featured-section {\n  font-family: Roboto;\n  border-radius: 5px;\n  color: #d2042d;\n  display: inline-flex;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  font-weight: 400;\n  font-size: 1rem;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n.map-label {\n  font-family: Roboto;\n  margin-right: 8px;\n  color: #000;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  display: inline-block;\n  padding-top: 0.4rem;\n}\n.switch-map {\n  width: 53px;\n  height: 26px;\n}\n.product-price {\n  color: #000;\n  font-size: var(--Font-Font-Size-h4, 20px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-top: 21px;\n  justify-content: end;\n  align-self: center;\n}\n.price-details {\n  font-family: Roboto;\n  display: inline-flex;\n}\n.action-buttons {\n  margin-top: 32px;\n  justify-content: end;\n}\n.delete-button {\n  padding: 0;\n}\n.negotiable-text {\n  font-family: Roboto;\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-left: 4px;\n  margin-top: 10px;\n}\n\n.transfer-product-header {\n  font-family: Montserrat;\n  color: #000;\n  font-size: var(--Font-Font-Size-h5, 1.4375rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.5rem;\n}\n\n.transfer-product-seller {\n  margin-top: 2rem;\n  margin-bottom: 2.5rem;\n}\n\n.transfer-product-radio .ant-radio-wrapper > span {\n  color: #000;\n  font-size: 1rem !important;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n\n.transfer-product-radio .ant-radio-inner {\n  width: 20px;\n  height: 20px;\n}\n\n.transfer-product .ant-select-item-option-state {\n  display: none !important;\n}\n\n.transfer-product-chip {\n  text-align: center;\n  padding: 0.5rem 0.625rem;\n  border-radius: 0.1875rem;\n  background: #ffd6de;\n  gap: 0.5rem;\n  display: flex;\n}\n\n.transfer-product-chip .ant-tag-close-icon {\n  color: #000;\n}\n.pagination {\n  display: flex;\n  padding: 1rem;\n  justify-content: end;\n}\n\n.product-labels {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.available-check {\n  .ant-checkbox-inner {\n    height: 1.5rem;\n    width: 1.5rem;\n  }\n}\n.filter-billBoards .vertical-divider {\n  stroke-width: 1px;\n  background-color: #000;\n  height: 1.6875rem;\n  margin: 0 1rem;\n}\n.datepickers {\n  position: relative;\n}\n.datepickers .ant-picker-panel-container {\n  width: 100% !important;\n}\n\n.select-type-drop-down {\n  width: auto !important;\n}\n\n.my-billboard-datepicker {\n  height: 2.375rem;\n  display: flex;\n  font: 0.8125rem;\n  padding: 0px 14px;\n  align-items: center;\n  gap: 12px;\n  border-radius: 5px;\n  width: 10.5rem;\n  border: 1px solid #e6e6e6;\n  border-bottom: none;\n  background: #fff;\n  .ant-picker-input > input::placeholder {\n    font-family: Roboto;\n    color: #0a0f0d;\n  }\n}\n\n.personal-details-datepicker {\n  border-color: #e6e6e6 !important;\n  border-bottom: 1px solid #e6e6e6 !important;\n  box-shadow: none !important;\n}\n\n.isAvailable {\n  font-family: Roboto;\n  width: max-content;\n}\n.my-billboard-datepicker-dropdown .ant-picker-date-panel {\n  width: 100% !important;\n}\n\n.filter-billBoards .ant-picker-panel-container.ant-picker-date-panel-container {\n  width: 15rem !important;\n}\n.ribbon-margin {\n  margin-top: 3.25rem;\n}\n.my-billboard-card .siteNumber {\n  color: var(--Colors-Primary-500, #8e9190);\n}\n.billboard-container .product-title {\n  font-family: Roboto;\n  word-wrap: break-word !important;\n  max-width: 80% !important;\n}\n\n.my-billboard-campaign-div {\n  gap: 0.5rem;\n  display: flex;\n}\n\n.my-billboard-campaign-col {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.siteName-image {\n  width: 22px !important;\n  margin: 12px;\n}\n\n.my-billboard-actions-div {\n  justify-content: flex-end;\n  display: flex;\n}\n.my-products-header {\n  margin-top: 10px;\n  height: 90px;\n  align-items: center;\n}\n.my-billboard-divider {\n  height: 23px;\n  border-inline-start: 1px solid rgb(5 5 5 / 48%);\n  margin: 1.125rem;\n}\n\n.my-billboard-back-arrow {\n  padding-left: 1rem;\n  padding-top: 1rem;\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.my-billboard-tag-css {\n  margin-top: 1rem;\n  display: flex;\n  gap: 0.2rem;\n  max-height: 4rem;\n  overflow-x: scroll;\n  flex-wrap: wrap;\n}\n\n.billboard-clear-all {\n  font-family: Roboto;\n  margin-left: 1rem;\n  cursor: pointer;\n  color: #d2042d;\n}\n.mobile-products-row {\n  overflow-y: scroll;\n  max-height: 65vh;\n  /* padding-right: 1rem; */\n}\n.slots-popover {\n  max-height: 25vh !important;\n  overflow-y: auto;\n}\n@media (min-width: 481px) and (max-width: 1025px) {\n  .my-billboard-card .product-labels {\n    font-size: 0.9rem;\n  }\n  .my-billboard-card .siteName {\n    font-size: 15px;\n  }\n  .available-check {\n    padding: 4px 10px 4px 0px;\n  }\n  .button-group {\n    justify-content: flex-start !important;\n    margin-top: 1rem;\n  }\n  .map-section {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n  }\n  .map-section .map-label {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .campaign,\n  .my-product {\n    min-width: 100vw I !important;\n  }\n  .my-billboard-container {\n    margin: 0rem 1.5rem;\n  }\n\n  .impressions-row {\n    border-radius: 10px;\n    background: var(--Colors-Background-300, #f8f8f8);\n    width: 100%;\n    max-width: 85vw;\n    height: auto;\n    padding: 10px 0;\n    flex-shrink: 0;\n    margin-top: 1.3125rem;\n    justify-content: center;\n    align-items: center;\n  }\n  .mobile-products-row .product-title {\n    font-size: 13px;\n  }\n  .price-actions {\n    justify-content: space-between;\n    margin-top: 1.1875rem;\n  }\n  .billboard-filter {\n    padding: 10px;\n    width: max-content;\n    background: #fff;\n    border-radius: 10px;\n  }\n  .map-label {\n    font-size: 13px;\n    margin-right: 0;\n    padding-top: 0.2rem;\n  }\n  .my-billboard-card .ant-card-body {\n    padding: 14px;\n  }\n  .my-billboard-card .product-title {\n    font-weight: 400;\n  }\n}\n\n@media (min-width: 0px) and (max-width: 769px) {\n  .custom-button {\n    background-color: #d2042d !important;\n    color: #fff !important;\n    height: 3rem !important;\n    width: 3rem !important;\n    font-size: 24px;\n  }\n  .my-billboard-campaign-div {\n    font-size: 1.4rem;\n  }\n  .my-products-header {\n    margin-top: 10px;\n    height: auto;\n    align-items: center;\n  }\n  .seller-multi-slot-arrow {\n    margin: 6px !important;\n  }\n  .floating-icon {\n    position: fixed;\n    bottom: 24px;\n    right: 13px;\n    z-index: 99;\n  }\n  .address-section {\n    margin-top: 15px !important;\n  }\n  .more-slots-dates-text {\n    font-size: 14px !important;\n  }\n}\n\n@media (min-width: 0px) and (max-width: 480px) {\n  .view-campaigns-header {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h6, 1.1875rem);\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    height: max-content;\n  }\n  .billboard-search {\n    margin-left: 0rem;\n    width: 100%;\n  }\n  .billboard-container {\n    display: inline-block;\n    margin-top: 2rem;\n    .ant-ribbon.ant-ribbon-placement-end {\n      right: 0.1%;\n    }\n    .ant-ribbon-wrapper {\n      margin-top: 1.5rem;\n    }\n  }\n  .product-card .ant-row {\n    padding: 0;\n  }\n  .billboard-segments {\n    width: 100%;\n    overflow-x: scroll;\n  }\n  .button-group {\n    justify-content: flex-start;\n    flex-wrap: nowrap;\n    margin-top: 0.5rem;\n    width: 365px;\n    overflow-x: scroll;\n  }\n  .featured {\n    color: var(--Colors-Primary-500, #d2042d);\n    font-size: var(--Font-Font-Size-small, 13px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .folder-icon {\n    padding-right: 10px;\n  }\n  .switch-map {\n    width: 33px;\n    height: 26px;\n    margin-left: 0.5rem;\n  }\n  .my-billboard-card .siteNumber {\n    color: var(--Colors-Primary-500, #d2042d);\n  }\n  .product-details-value {\n    color: #000;\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .my-billboard-card .dates {\n    margin-top: 1rem;\n  }\n  .product-labels {\n    font-size: 13px;\n  }\n  .product-img-section {\n    margin-top: 2rem;\n  }\n  .address-section {\n    margin-top: 3px;\n  }\n  .product-img {\n    width: 120px;\n    height: 104px;\n    flex-shrink: 0;\n    border-radius: 10px;\n    border: 0.5px solid grey;\n  }\n  .product-price {\n    justify-content: flex-start;\n    flex-direction: column;\n  }\n  .negotiable-text {\n    margin-top: 0;\n  }\n  .dates-arrow {\n    padding: 0 0.5rem;\n  }\n\n  .custom-button {\n    background-color: #d2042d !important;\n    color: #fff !important;\n    height: 3rem !important;\n    width: 3rem !important;\n    font-size: 24px;\n  }\n  .align-flex {\n    display: flex;\n    flex-direction: column;\n  }\n  .action-btns {\n    font-family: Roboto;\n    align-self: flex-start;\n  }\n\n  .price-details {\n    overflow: hidden;\n    color: #000;\n    text-overflow: ellipsis;\n    font-size: var(--Font-Font-Size-h5, 23px);\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n  .billboard-action-button {\n    border: none;\n    border-radius: 5px;\n    background: #f5f5f5;\n    display: flex;\n    width: 51px;\n    height: 50px;\n    padding: 3px 7px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n  .floating-icon {\n    position: fixed;\n    bottom: 24px;\n    right: 13px;\n    z-index: 99;\n  }\n\n  .align-flex {\n    display: flex;\n    flex-direction: column;\n  }\n  .action-btns {\n    align-self: flex-start;\n  }\n  .price-actions {\n    justify-content: space-between;\n    margin-top: 1.1875rem;\n  }\n  .price-details {\n    overflow: hidden;\n    color: #000;\n    text-overflow: ellipsis;\n    font-size: var(--Font-Font-Size-h5, 23px);\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n  .billboard-action-button {\n    border: none;\n    border-radius: 5px;\n    background: #f5f5f5;\n    display: flex;\n    width: 51px;\n    height: 40px;\n    padding: 3px 7px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n}\n\n.myBillboard-icons {\n  width: 1rem;\n  height: 1rem;\n}\n@media (max-width: 768px) {\n  .product-labels {\n    font-size: 14px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
